import { render, staticRenderFns } from "./DataLoading.vue?vue&type=template&id=4a12f822&scoped=true&"
import script from "./DataLoading.vue?vue&type=script&lang=ts&"
export * from "./DataLoading.vue?vue&type=script&lang=ts&"
import style0 from "./DataLoading.vue?vue&type=style&index=0&id=4a12f822&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a12f822",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
